/**
 * Display-only formatting for server-computed quantities (Phase 4 shopping
 * list). Per the house rule: total_oz and bottle counts are numbers the
 * server computed — the frontend rounds oz to 1 decimal for DISPLAY only
 * and never recomputes the underlying quantity. Bottle counts are already
 * whole numbers from the server and are rendered as-is (no rounding needed).
 */
export function formatOz(oz: number): string {
  return `${oz.toFixed(1)} oz`;
}
